export default {
  CALLBACK_SUBMITTED: 'callback.submitted',
  FEEDBACK_SUBMITTED: 'feedback.submitted',
  PRODUCT_OPENED: 'product.opened',
  PRODUCT_ADDED_TO_ORDER: 'product.addedToOrder',
  PRODUCT_REMOVED_FROM_ORDER: 'product.removedFromOrder',
  ORDER_SUBMISSION_STARTED: 'order.submissionStarted',
  ORDER_SUBMITTED: 'order.submitted',
}
